import { createContext, useContext } from 'react';

import { IDomain } from '../../../interfaces/domain';

export const DomainContext = createContext<IDomain | null>(null);
export const useDomainContext = () => useContext(DomainContext);
